module.exports = __webpack_public_path__ + "img/agri.e1fdfa01.png";